import React, {FC} from 'react';
import styled from 'styled-components';
import {FONT_WEIGHTS} from '../../../../constants/typography';
import {ImageType} from '../../../../types/Image';
import {Image} from '../../../atoms/Image/Image';
import {Ratio} from '../../../atoms/Image/types';
import {
  ContentBlockText,
  ContentBlockTextProps,
} from '../ContentBlockText/ContentBlockText';

export interface Props {
  text: ContentBlockTextProps;
  logo?: ImageType & {aspectRatio: Ratio};
  testId?: string;
  className?: string;
}

export const ContentBlockHeadline: FC<Props> = ({
  text,
  logo,
  testId = 'contentBlockHeadline',
  className,
}) => {
  return text.text || logo ? (
    <Wrapper className={className} data-testid={testId}>
      {logo && (
        <StyledImage
          alt={logo.description}
          breakpoints={breakpoints}
          ratio={logo.aspectRatio}
          src={logo.url}
          loading="lazy"
          widths={possibleImageWidths}
          data-testid={`${testId}Background`}
        />
      )}
      {text.text !== '' && (
        <StyledContentBlockText
          alignment={text.alignment}
          color={text.color}
          size={text.size}
          text={text.text}
          testId={`${testId}Text`}
        />
      )}
    </Wrapper>
  ) : null;
};

const breakpoints = [
  {
    columns: 1,
  },
];

const possibleImageWidths = [140];

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const StyledImage = styled(Image)`
  margin-bottom: 0.5rem;
  max-width: 140px;
`;

const StyledContentBlockText = styled(ContentBlockText)`
  font-weight: ${FONT_WEIGHTS.bold};
`;
